import BaseModel from '../BaseModel';

export default class Resume extends BaseModel {
  static entity = 'resumes';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      candidateId: this.attr(null),
      file: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      store(id, resume) {
        return this.post(`candidates/${id}/resume`, resume);
      },
      destroy(resumeId) {
        return this.delete(`candidates/resume/${resumeId}`, { delete: resumeId });
      },
    },
  }
}
